import { TweenMax } from 'gsap/TweenMax'
import * as PIXI from 'pixi.js'
import Score from './score.js'
import orientation from './orientation.js'
import track from './track.js'

class Scene4 {
  constructor (game) {
    this.game = game
  }

  enter (score) {
    this.game.background
      .set(this.game.background.defaultColor)
      .setTextureAlpha(1)

    // Manifest
    this.textures = {
      gameOver: PIXI.Texture.from('gameOver'),
      btnGoToLanding: PIXI.Texture.from('btnGoToLanding'),
      btnShare: PIXI.Texture.from('btnShare'),
      scoreBoard: PIXI.Texture.from('scoreBoard'),
      scoreBoardPlayAgain: PIXI.Texture.from('scoreBoardPlayAgain'),
      jumper1: PIXI.Texture.from('jumper1'),
      jumper2: PIXI.Texture.from('jumper2'),
      jumper3: PIXI.Texture.from('jumper3'),
      jumper4: PIXI.Texture.from('jumper4'),
      jumper5: PIXI.Texture.from('jumper5'),
      jumper6: PIXI.Texture.from('jumper6'),
      jumper7: PIXI.Texture.from('jumper7'),
      btnRule: PIXI.Texture.from('btnRule'),
      input: PIXI.Texture.from('input'),
      footerCredit: PIXI.Texture.from('credit')
    }

    this.score = new Score(this.game)
    this.score.value = score
    this.game.lastScore = score
    this.score.update()
    this.score.container.y = 102

    this.container = new PIXI.Container()

    this.gameOver = new PIXI.Sprite(this.textures.gameOver)
    this.scoreBoard = new PIXI.Sprite(this.textures.scoreBoard)
    this.footer = new PIXI.Sprite(this.textures.footerCredit)

    this.scoreText = this.score.getLevelText()
    this.scoreBoardPlayAgain = new PIXI.Sprite(this.textures.scoreBoardPlayAgain)
    this.btnGoToLanding = new PIXI.Sprite(this.textures.btnGoToLanding)
    this.btnShare = new PIXI.Sprite(this.textures.btnShare)
    this.btnRule = new PIXI.Sprite(this.textures.btnRule)
    this.input = new PIXI.Sprite(this.textures.input)
    this.jumper = new PIXI.extras.AnimatedSprite([
      this.textures.jumper1,
      this.textures.jumper2,
      this.textures.jumper3,
      this.textures.jumper4,
      this.textures.jumper5,
      this.textures.jumper6,
      this.textures.jumper7
    ])

    this.gameOver.scale.set(0.25)
    this.scoreBoard.scale.set(0.25)
    this.btnGoToLanding.scale.set(0.25)
    this.btnShare.scale.set(0.25)
    this.scoreBoardPlayAgain.scale.set(0.25)
    this.jumper.scale.set(0.25)
    this.btnRule.scale.set(0.25)
    this.input.scale.set(0.25)
    this.footer.scale.set(0.25)

    this.jumper.animationSpeed = 0.125
    this.jumper.play()

    this.gameOver.x = (this.game.app.renderer.realWidth / 2) - (this.gameOver.width / 2)
    this.scoreBoard.x = (this.game.app.renderer.realWidth / 2) - (this.scoreBoard.width / 2)
    this.scoreBoard.y = 40
    this.scoreText.x = 135
    this.scoreText.y = 180
    this.jumper.x = 11
    this.jumper.y = 121
    this.scoreBoardPlayAgain.x = (this.game.app.renderer.realWidth / 2) - (this.scoreBoardPlayAgain.width / 2)
    this.scoreBoardPlayAgain.y = 227
    this.btnRule.x = (this.game.app.renderer.realWidth / 2) - (this.btnRule.width / 2)
    this.btnRule.y = 481
    this.btnShare.x = 15
    this.btnShare.y = 402
    this.btnGoToLanding.x = this.btnShare.x + this.btnShare.width + 5
    this.btnGoToLanding.y = 402
    this.input.x = (this.game.app.renderer.realWidth / 2) - (this.input.width / 2)
    this.input.y = 341
    this.footer.x = 0
    this.footer.y = this.game.app.renderer.realHeight

    this.btnRule.interactive = true
    this.btnRule.buttonMode = true
    this.btnRule.on('click', this.openRulePage, this)
    this.btnRule.on('touchend', this.openRulePage, this)

    this.scoreBoardPlayAgain.interactive = true
    this.scoreBoardPlayAgain.buttonMode = true
    this.scoreBoardPlayAgain.on('click', this.playAgain, this)
    this.scoreBoardPlayAgain.on('touchend', this.playAgain, this)

    this.btnGoToLanding.interactive = true
    this.btnGoToLanding.buttonMode = true
    this.btnGoToLanding.on('click', this.openLandingPage, this)
    this.btnGoToLanding.on('touchend', this.openLandingPage, this)

    this.btnShare.interactive = true
    this.btnShare.buttonMode = true
    this.btnShare.on('click', this.share, this)
    this.btnShare.on('touchend', this.share, this)

    this.input.interactive = true
    this.input.buttonMode = true
    this.input.on('click', this.openEmailDialog, this)
    this.input.on('touchend', this.openEmailDialog, this)

    this.footer.interactive = true
    this.footer.buttonMode = true
    this.footer.on('click', this.onClickCreditFooter, this)
    this.footer.on('touchend', this.onClickCreditFooter, this)

    this.container.addChild(
      this.gameOver,
      this.scoreBoardPlayAgain,
      this.scoreBoard,
      this.scoreText,
      this.input,
      this.jumper,
      this.score.container,
      this.btnRule,
      this.btnGoToLanding,
      this.btnShare
    )

    this.container.y = -this.container.height
    this.game.app.stage.addChild(this.container, this.footer)

    if (this.container) {
      this.animeContainer = TweenMax.to(this.container, 1.35, {
        pixi: { y: 20 },
        ease: 'easeOutBack',
        onComplete: () => {
          if (this.btnShare) {
            this.floatingBtnShare = TweenMax.to(this.btnShare, 0.4, {
              pixi: {
                y: 407
              },
              yoyo: true,
              repeat: -1
            })
          }

          if (this.footer) {
            TweenMax.to(this.footer, 0.6, {
              pixi: {
                y: this.game.app.renderer.realHeight - this.footer.height
              },
              ease: 'easeOutSine'
            })
          }
        }
      })
    }
  }

  leave () {
    this.btnShare.interactive = false
    this.btnShare.buttonMode = false
    this.btnShare.off('click', this.share)
    this.btnShare.off('touchend', this.share)

    this.input.interactive = false
    this.input.buttonMode = false
    this.input.off('click', this.openEmailDialog)
    this.input.off('touchend', this.openEmailDialog)

    this.btnGoToLanding.interactive = false
    this.btnGoToLanding.buttonMode = false
    this.btnGoToLanding.off('click', this.openLandingPage)
    this.btnGoToLanding.off('touchend', this.openLandingPage)

    this.btnRule.interactive = false
    this.btnRule.buttonMode = false
    this.btnRule.off('click', this.openRulePage)
    this.btnRule.off('touchend', this.openRulePage)

    this.scoreBoardPlayAgain.interactive = false
    this.scoreBoardPlayAgain.buttonMode = false
    this.scoreBoardPlayAgain.off('click', this.playAgain)
    this.scoreBoardPlayAgain.off('touchend', this.playAgain)

    this.footer.interactive = false
    this.footer.buttonMode = false
    this.footer.off('click', this.onClickCreditFooter)
    this.footer.off('touchend', this.onClickCreditFooter)

    this.game.app.stage.removeChild(this.container, this.footer)

    this.container.destroy()
    this.btnGoToLanding.destroy()
    this.btnShare.destroy()
    this.footer.destroy()

    this.container = null
    this.btnGoToLanding = null
    this.btnShare = null
    this.footer = null
    this.textures = null
    this.score = null
    this.levelText = null

    TweenMax.killTweensOf(this.animeContainer)
    TweenMax.killTweensOf(this.floatingBtnShare)
  }

  openEmailDialog () {
    if (this.game.audioEnabled) {
        PIXI.sound.play('audioPop')
    }

    const email = window.prompt('請輸入您的 e-mail\n為求中獎後方便與您聯繫運送地址和需求，MR. LIVING 居家先生請您留下 e-mail，不作本專案外的使用')
    if (email) {
      const hhmmss = this.score.toHHMMSS(this.score.value)
      const timestamp = `${hhmmss[0]} 天 ${hhmmss[1]} 小時 ${hhmmss[2]} 分鐘`

      // GA 紀錄 Email
      track('event', `gameOver_userEmail-${timestamp}`, {
        category: this.game.id,
        label: email
      })

      this.input.texture = PIXI.Texture.from('inputDone')
      this.input.interactive = false
      this.input.buttonMode = false
    }

    track('event', 'gameOver_userEmailButton', {
      category: this.game.id,
      label: 'click'
    })
  }

  onClickCreditFooter () {
    if (this.game.audioEnabled) {
      PIXI.sound.play('audioPop')
    }

    track('event', 'gameOver_buttonCredit', {
      category: this.game.id,
      label: 'click'
    })

    const win = window.open('https://backer-founder.com/?utm_source=gamesite&utm_medium=button_bf_home&utm_campaign=game', '_blank')
    if (win) {
      win.focus()
    }
  }

  playAgain () {
    if (this.game.audioEnabled) {
      PIXI.sound.play('audioPop')
    }

    track('event', 'gameOver_buttonPlayAgian', {
      category: this.game.id,
      label: 'click'
    })

    this.game.lastScore = null

    if (this.onPlayAgain) {
      this.onPlayAgain()
    }
  }

  openLandingPage () {
    if (this.game.audioEnabled) {
      PIXI.sound.play('audioPop')
    }

    track('event', 'gameOver_buttonMrliving', {
      category: this.game.id,
      label: 'click'
    })

    const win = window.open('https://www.mattress.mrliving.com.tw/?utm_source=gamesite&utm_medium=button_landing_page&utm_campaign=game', '_blank')
    if (win) {
      win.focus()
    }
  }

  openRulePage () {
    if (this.game.audioEnabled) {
      PIXI.sound.play('audioPop')
    }

    track('event', 'gameOver_buttonRulePage', {
      category: this.game.id,
      label: 'click'
    })

    const win = window.open('https://www.mattress.mrliving.com.tw/game?utm_source=gamesite&utm_medium=button_rule_page&utm_campaign=game', '_blank')
    if (win) {
      win.focus()
    }
  }

  share () {
    if (this.game.audioEnabled) {
      PIXI.sound.play('audioPop')
    }

    track('event', 'gameOver_buttonShare', {
      category: this.game.id,
      label: 'click'
    })

    const hhmmss = this.score.toHHMMSS(this.score.value)
    const timestamp = `${hhmmss[0]} 天 ${hhmmss[1]} 小時 ${hhmmss[2]} 分鐘`

    window.FB.ui({
      method: 'share',
      display: 'popup',
      href: 'http://game.mrliving.com.tw/?utm_source=fb&utm_medium=share&utm_campaign=game',
      hashtag: '#居哥夢遊仙境101夜',
      quote: `我睡了 ${timestamp}爽啦！

生活這麼累，今天就讓自己睡好一點吧！

現在預購 MR. LIVING 恆溫冷凝記憶棉床墊，還贈送一起睡到天荒地老的恆溫冷凝記憶枕！
>> 請點進：https://www.mattress.mrliving.com.tw/
>> 或在 FB 搜尋：MR. LIVING 居家先生`
    }, res => {
      if (res && !res.error_message) {
        track('event', 'gameOver_buttonShare', {
          category: this.game.id,
          label: 'success'
        })
      } else {
        track('event', 'gameOver_buttonShare', {
          category: this.game.id,
          label: 'cancel'
        })
      }
    })
  }
}

export default Scene4
